import Filter from "./Filter.js";

function ActivityFilter( {onClick, isClicked} ) {
    return (
      <Filter onClick={onClick} isClicked={isClicked} text={"Attività"}/>
    );
  }
  
  export default ActivityFilter;